var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardDraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31482 5.09259C2.31482 3.47222 3.7037 2.08333 5.32407 2.08333H22.2222C23.8426 2.08333 25.2315 3.47222 25.2315 5.09259V14.3519C25.2315 15.9722 23.8426 17.3611 22.2222 17.3611H15.9722H11.5741H5.32407C3.7037 17.3611 2.31482 15.9722 2.31482 14.3519V5.09259ZM14.8148 22.6852H12.5V19.4444H14.8148V22.6852ZM5.09259 19.4444H10.1852V22.6852H6.25C5.55556 22.6852 5.09259 23.1481 5.09259 23.8426C5.09259 24.537 5.55556 25 6.25 25H11.3426H15.7407H20.8333C21.5278 25 21.9907 24.537 21.9907 23.8426C21.9907 23.1481 21.5278 22.6852 20.8333 22.6852H16.8981V19.4444H21.9907C24.7685 19.4444 27.0833 17.1296 27.0833 14.3519V5.09259C27.0833 2.31481 24.7685 0 21.9907 0H5.09259C2.31482 0 0 2.31481 0 5.09259V14.3519C0 17.1296 2.31482 19.4444 5.09259 19.4444Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48138 9.72204H15.9721C16.6666 9.72204 17.1295 9.25908 17.1295 8.56463C17.1295 7.87019 16.6666 7.40723 15.9721 7.40723H6.48138C5.78694 7.40723 5.32397 7.87019 5.32397 8.56463C5.32397 9.25908 5.78694 9.72204 6.48138 9.72204Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48138 14.8148H12.4999C13.1943 14.8148 13.6573 14.3519 13.6573 13.6574C13.6573 12.963 13.1943 12.5 12.4999 12.5H6.48138C5.78694 12.5 5.32397 12.963 5.32397 13.6574C5.32397 14.3519 5.78694 14.8148 6.48138 14.8148Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardDraw);
export default __webpack_public_path__ + "static/media/dashboardDraw.35c7d9c2995777f04e16603bb8043474.svg";
export { ForwardRef as ReactComponent };